// extracted by mini-css-extract-plugin
export var actions = "style-module--actions--0a97e";
export var approvalWarning = "style-module--approvalWarning--d58ce";
export var name = "style-module--name--8bff5";
export var noRegistrationWarning = "style-module--noRegistrationWarning--f82f8";